// extracted by mini-css-extract-plugin
export default {"main":"OfferPage_main__rseCC","content":"OfferPage_content__tYDc2","items":"OfferPage_items__J8txD","header":"OfferPage_header__Dd3xa"};